import { te } from "intl-tel-input/i18n";
import HomePageComponents from "../../src/components/HomePageComponents/HomePageComponents";
import HomePage from "../pages/HomePage/HomePage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import termsAndConditions from "../pages/Terms&Conditions";

const routes = [
  {
    path: "/",
    element: HomePage,
    children: [
      { path: "", element: HomePageComponents },
      { path: "privacy", element: PrivacyPolicy },
      { path: "terms&conditions", element: termsAndConditions },
    ],
  },
];

export default routes;
